import React from "react";
import { useSelector } from "react-redux";
import Order from "../../Common/Order";
import Payment from "../../Common/Payment";
import Trx from "../../Common/Trx";
import UserBuyer from "../../Common/UserBuyer";

const Index = ({ data }) => {
  const { user_type } = useSelector(state => state);
  return (
    <div>
      {user_type == "admin" ? <UserBuyer userbuyer={data.user_buyer} /> : <></>}
      <Order order={data.order} />
      <Payment payment={data.peyment} />
      <Trx trx={data.trx} />
    </div>
  );
};

export default Index;
